import { render, staticRenderFns } from "./MessagesIndex.vue?vue&type=template&id=d1525c84&scoped=true&"
import script from "./MessagesIndex.vue?vue&type=script&lang=js&"
export * from "./MessagesIndex.vue?vue&type=script&lang=js&"
import style0 from "./MessagesIndex.vue?vue&type=style&index=0&id=d1525c84&scoped=true&lang=scss&"
import style1 from "./MessagesIndex.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1525c84",
  null
  
)

export default component.exports